// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-area-style{
    padding:20px;
}
.addQuestionSelectInput{
    margin-bottom: 10px;
}
.addQuestionSelectInput .css-13cymwt-control{
    background: var(--field-background) !important;
    border: none !important;
    padding: 7px 10px !important;
    border-radius: 20px;
}
.addQuestionSelectPlaceHolderStyle {
    font-size: 16px !important;
    color: var(--placeholder-grey) !important;
    font-family: var(--inter-Regular);
}
.desc::placeholder>span{
    color: red !important;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/addEditVideoTutorialsModal/AddEditVideoTutorialsModal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,8CAA8C;IAC9C,uBAAuB;IACvB,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,iCAAiC;AACrC;AACA;IACI,qBAAqB;AACzB","sourcesContent":[".text-area-style{\n    padding:20px;\n}\n.addQuestionSelectInput{\n    margin-bottom: 10px;\n}\n.addQuestionSelectInput .css-13cymwt-control{\n    background: var(--field-background) !important;\n    border: none !important;\n    padding: 7px 10px !important;\n    border-radius: 20px;\n}\n.addQuestionSelectPlaceHolderStyle {\n    font-size: 16px !important;\n    color: var(--placeholder-grey) !important;\n    font-family: var(--inter-Regular);\n}\n.desc::placeholder>span{\n    color: red !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
